// extracted by mini-css-extract-plugin
module.exports = {"RemovePart":"w3V0jtuUwnuvyMwf8Wbq6g=="};